module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-150x150-e0ef0d1e10dad71b4fdbd6fd82da7010.png";